import { contractAddresses } from "web3/addresses"

import { useBBToken } from "./use-bb-token"
import type { WALLET_CONNECTION_TYPES } from "./use-wallet"

export function useBITSToken(connectionType?: WALLET_CONNECTION_TYPES) {
  return useBBToken(contractAddresses.BITS, connectionType)
}
